import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadInterests } from "../Interests/loadData";
import { loadSkills } from "../Skills/loadData";
import { AddDocumentLookUp } from "./addDocumentLookUp";
import { loadLookupsList, loadLookupsTypes } from "./loadData";
import { lookupListHeaders } from "./tableHeaders";

const DocumentLookUp = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [lookupsList, setLookupsList] = useState([]);
  const [lookupsTypes, setLookupsTypes] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);

  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});

  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);

  useEffect(() => {
    loadLookupsList(setLoading).then(setLookupsList);
    loadLookupsTypes(setLoading).then(setLookupsTypes);
  }, [location.pathname, update]);

  const filteredLookupsList = lookupsList?.filter(
    (lookup) => lookup.lookupType === "documentType"
  );
  console.log("filteredLookupsList", filteredLookupsList);
  const filteredLookupsTypes = lookupsTypes?.filter(
    (lookupType) => lookupType === "documentType"
  );
  filteredLookupsList?.map((lookup, index) => (lookup.id = index));
  let url = `lookup/deleteLookup/${deleteData?._id}`;
  return (
    <AdminPage title={"Document Types"}>
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Document Type Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.lookupName}
            type={viewModalData?.lookupType}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Document Type"}
        InternalComponent={
          <DeleteModalContent
            route={url}
            type={"Document Type"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddDocumentLookUp
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        lookupsTypes={filteredLookupsTypes}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={lookupListHeaders}
          rowData={filteredLookupsList}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalState={setViewModalState}
          setViewModalData={setViewModalData}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default DocumentLookUp;
